module.exports = __webpack_public_path__ + "png/icon1.png?37c69e8611fa996ff669f949e72f790c";